module.exports = __webpack_public_path__ + "static/img/6.c7f77be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/clix/6.png
// module id = /Zfk
// module chunks = 35